import { useState, useEffect } from "react";
import ThemeToggle from "./ThemeToggle";

export default function Navigation({ lang, setLang, onShowBlog, theme, setTheme }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`nav ${scrolled ? "nav-scrolled" : ""}`} data-testid="navigation" aria-label={lang === "DE" ? "Hauptnavigation" : lang === "EN" ? "Main navigation" : "Navigation principale"}>
      <a href="#hero" className="nav-logo" aria-label="UNDRIVE - Startseite">
        UNDRIVE<sup className="nav-triangle-wrap" aria-hidden="true"><svg className="nav-triangle" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0 0L28 0L28 28Z" fill="#E8952A"/></svg></sup><sup className="trademark" aria-hidden="true">®</sup>
      </a>
      <div className="nav-right">
        <a href="#termin" className="nav-booking-btn" data-testid="nav-booking-btn">
          {lang === "DE" ? "Termin buchen" : lang === "EN" ? "Book meeting" : "Rendez-vous"}
        </a>
        <button
          className="nav-blog-btn"
          onClick={onShowBlog}
          data-testid="nav-blog-btn"
        >
          Blog
        </button>
        <ThemeToggle theme={theme} setTheme={setTheme} />
        <div className="lang-switch" role="group" aria-label={lang === "DE" ? "Sprache wählen" : lang === "EN" ? "Select language" : "Choisir la langue"}>
          {["DE", "EN", "FR"].map(l => (
            <button
              key={l}
              className={`lang-btn ${lang === l ? "active" : ""}`}
              onClick={() => setLang(l)}
              data-testid={`lang-btn-${l.toLowerCase()}`}
              aria-current={lang === l ? "true" : undefined}
              aria-label={l === "DE" ? "Deutsch" : l === "EN" ? "English" : "Français"}
            >
              {l}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
